var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"ma-1",attrs:{"dark":"","small":"","color":_vm.statusColor}},[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(" mdi-access-point ")]),_vm._v(" "+_vm._s(_vm.statusTile)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }